/* import __COLOCATED_TEMPLATE__ from './segment-list.hbs'; */
/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import FilteredObjectList from 'embercom/components/filtered-object-list';

const SEGMENT_HEIGHT = 33;

export default FilteredObjectList.extend({
  objectHeight: SEGMENT_HEIGHT,
});
